import api from '@/services/api'

export const state = () => ({
  myInfo: null,
  myQRInfo: null,
  isLoadingQR: false,
  searchUserList: [],
  searchUserCancelSource: null
})
export const getters = {
  myInfo (state) {
    return state.myInfo
  },
  myQRInfo (state) {
    return state.myQRInfo
  },
  myQRImage (state) {
    if (state.myQRInfo && state.myQRInfo.qrcode) {
      return state.myQRInfo.qrcode
    }
    return null
  },
  isActivated (state, getters, rootState) {
    const isMigrated = rootState.app.isMigrated
    if (isMigrated) {
      return state.myInfo && state.myInfo.member_info && state.myInfo.member_info.is_verified
    } else {
      return state.myInfo && state.myInfo.coworker && state.myInfo.coworker.Active
    }
  },
  isValidated (state, getters, rootState) {
    const isMigrated = rootState.app.isMigrated
    if (isMigrated) {
      return state.myInfo && state.myInfo.is_validated
    }
    return false
  },
  isLoadingQR (state) {
    return state.isLoadingQR
  },
  searchUserList (state) {
    return state.searchUserList
  },
  searchUserCancelSource (state) {
    return state.searchUserCancelSource
  }
}
export const actions = {
  GET_MY_INFO ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getMyInfo()
        .then((myInfo) => {
          if (myInfo.force_logout) {
            commit('CLEAR_MY_INFO')
            dispatch('auth/LOGOUT', null, {
              root: true
            })
            resolve()
            return
          }
          commit('GET_MY_INFO_SUCCESS', myInfo)
          if (typeof this.app.$sentry !== 'undefined') {
            this.app.$sentry.configureScope((scope) => {
              scope.setUser({
                id: myInfo.Id,
                email: myInfo.email
              })
            })
          }
          resolve(myInfo)
        }).catch((e) => {
          if (e.Message === 'An error has occurred.') {
            commit('CLEAR_MY_INFO')
            dispatch('auth/LOGOUT', null, {
              root: true
            })
          }
          reject(e)
        })
    })
  },
  CLEAR_MY_INFO ({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_MY_INFO')
      resolve()
    })
  },
  GET_MY_QR_CODE ({ commit, getters }) {
    return new Promise((resolve, reject) => {
      // generate new QR code
      api(this.app.context)
        .generateMyQR()
        .then((myQR) => {
          commit('MY_QR_UPDATED', myQR)
          resolve(myQR)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  START_LOADING_QR ({ commit }) {
    return new Promise((resolve) => {
      commit('LOADING_QR_STARTED')
      resolve()
    })
  },
  STOP_LOADING_QR ({ commit }) {
    return new Promise((resolve) => {
      commit('LOADING_QR_STOPPED')
      resolve()
    })
  },
  SEARCH_USER ({ commit, getters }, query) {
    let searchUserCancelSource = getters.searchUserCancelSource
    if (searchUserCancelSource === null) {
      const CancelToken = this.app.context.$axios.CancelToken
      searchUserCancelSource = CancelToken.source()
      commit('SAVE_SEARCH_CANCELLATION_SOURCE', searchUserCancelSource)
    } else {
      searchUserCancelSource.cancel()
    }
    return new Promise((resolve, reject) => {
      api(this.app.context, searchUserCancelSource)
        .searchUsers(query)
        .then((userList) => {
          console.log('userList', userList)
          commit('SEARCH_USER_SUCCESS', userList)
          commit('CLEAR_SEARCH_CANCELLATION_SOURCE')
          resolve(userList)
        }).catch((e) => {
          console.log('fail', e)
          commit('CLEAR_SEARCH_CANCELLATION_SOURCE')
          reject(e)
        })
    })
  },
  GET_ACTIVE_PRIVILEGE (ctx) {
    // console.log('payload', payload)
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getActivePrivileges()
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  ADMIN_VERIFY_USER (ctx, payload) {
    // console.log('payload', payload)
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .adminVerifyUser(payload)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  ADMIN_QUERY_ACCESS_REPORT (ctx, { fromDate, endDate }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .adminQueryAccessReport(fromDate, endDate)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  ADMIN_GET_PENALTY_HISTORY (ctx, id) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getPenaltyHistoryList(id)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  UPDATE_USER_EMAIL ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .updateUserEmail(payload)
        .then((myInfo) => {
          commit('GET_MY_INFO_SUCCESS', myInfo)
          resolve(myInfo)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  UPDATE_USER_PASSWORD (ctx, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .updateUserPassword(payload)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  UPDATE_USER_PROFILE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .updateUserProfile(payload)
        .then((myInfo) => {
          commit('GET_MY_INFO_SUCCESS', myInfo)
          resolve(myInfo)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  UPDATE_USER_PROFILE_IMAGE ({ commit }, formData) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .updateUserProfileImage(formData)
        .then((myInfo) => {
          commit('GET_MY_INFO_SUCCESS', myInfo)
          resolve(myInfo)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  SEND_VERIFICATION_CODE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .sendVerificationCode(payload)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  CONFIRM_VERIFICATION_CODE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .confirmVerificationCode(payload)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  DELETE_MY_ACCOUNT ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .deleteMyAccount()
        .then((result) => {
          commit('CLEAR_MY_INFO')
          dispatch('auth/LOGOUT', null, {
            root: true
          })
          resolve()
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  }
}
export const mutations = {
  GET_MY_INFO_SUCCESS (state, myInfo) {
    state.myInfo = myInfo
  },
  CLEAR_MY_INFO (state, myInfo) {
    state.myInfo = null
    state.myQRInfo = null
  },
  MY_QR_UPDATED (state, myQR) {
    state.myQRInfo = myQR
  },
  LOADING_QR_STARTED (state) {
    state.isLoadingQR = true
  },
  LOADING_QR_STOPPED (state) {
    state.isLoadingQR = false
  },
  SEARCH_USER_SUCCESS (state, userList) {
    state.searchUserList = userList
  },
  SAVE_SEARCH_CANCELLATION_SOURCE (state, source) {
    state.searchUserCancelSource = source
  },
  CLEAR_SEARCH_CANCELLATION_SOURCE (state) {
    state.searchUserCancelSource = null
  }
}
